import { DIRECT_BOOKING_BASE_LAYOUT } from 'src/constants/common';

export const DIRECT_BOOKING_LAYOUT = {
  ...DIRECT_BOOKING_BASE_LAYOUT,
  main: {
    withNavy050BG: true,
    withNavy050BGMobile: true,
  },
};

export const DIRECT_BOOKING_HEADER_TRIGGER_ID = 'direct-booking-header-trigger';
